import type { FC } from 'react';
import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LogicalOperator } from 'src/constants/dataline';
import { DRAG_ITEM_TYPES } from 'src/constants/dragItem';
import LogicalOperatorWrapper from 'src/components/common/Dataline/components/LogicalOperator';
import Shaping from 'src/components/common/Dataline/components/Shaping';

interface DatalineFragmentProps {
  comparisons: any[];
  definitionlineRenderId: string;
  isReadOnly: boolean;
}

const DatalineFragment: FC<DatalineFragmentProps> = ({
  comparisons,
  definitionlineRenderId,
  isReadOnly,
}) => {
  const { t } = useTranslation('workspace');
  const datalineContainsOrgUnit = useMemo(
    () =>
      comparisons.some(
        (comparison) => comparison.variable === DRAG_ITEM_TYPES.ORG_UNIT,
      ),
    [comparisons],
  );

  if (datalineContainsOrgUnit) return null;

  return (
    <Fragment>
      <Shaping
        isDummy
        dummyParentRenderId={definitionlineRenderId}
        shapingNames={['']}
        shapingRenderId="staticDummyRenderId"
        variableName={t('missingOrgUnit')}
        variable=""
        isReadOnly={isReadOnly}
      />
      {comparisons.length > 0 && ( // Only render the operator if there are more than one comparison.
        <LogicalOperatorWrapper
          comparisonRenderId="staticDummyRenderId"
          operator={LogicalOperator.AND}
          isReadOnly={isReadOnly}
        />
      )}
    </Fragment>
  );
};

export default DatalineFragment;
